document.addEventListener('click', (e) => {
  const tagEl = e.target.closest('[data-tag-link]');
  if (!tagEl) return;
  e.preventDefault();
  e.stopPropagation();
  window.location.href = tagEl.dataset.tagLink;
});

document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('[data-more-reads-track]');
  const prevBtn = document.querySelector('[data-more-reads-prev]');
  const nextBtn = document.querySelector('[data-more-reads-next]');

  if (!track) return;

  const updateNavState = () => {
    if (!prevBtn || !nextBtn) return;
    const atStart = track.scrollLeft <= 0;
    const atEnd = Math.abs(track.scrollLeft + track.clientWidth - track.scrollWidth) < 2;
    const noOverflow = track.scrollWidth <= track.clientWidth;

    if (atStart) {
      prevBtn.setAttribute('data-hidden', '');
    } else {
      prevBtn.removeAttribute('data-hidden');
    }

    if (atEnd || noOverflow) {
      nextBtn.setAttribute('data-hidden', '');
    } else {
      nextBtn.removeAttribute('data-hidden');
    }
  };

  let cachedScrollAmount = null;

  const getScrollAmount = () => {
    if (cachedScrollAmount !== null) return cachedScrollAmount;
    const card = track.querySelector('[data-more-reads-card]');
    if (!card) return 280;
    cachedScrollAmount = card.getBoundingClientRect().width + 20;
    return cachedScrollAmount;
  };

  const resizeObserver = new ResizeObserver(() => {
    cachedScrollAmount = null;
    updateNavState();
  });
  resizeObserver.observe(track);

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  }

  let rafId = null;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(updateNavState);
  });

  updateNavState();
});
